// @flow

import React, { Component } from 'react';
import styler from 'react-styling';

import getAvatarLetters from '../libs/AvatarLetters';
import getRandomColor from '../libs/Random';

function _createStyle(props, bgColor) {
  return styler `
    ImagePlaceholder
      height: ${props.height}
      width: ${props.width}
      float: left
      margin: ${props.margin}
      color: #ffffff
      background-color: ${bgColor}
      border-radius: 30px
      display: flex
      flex-direction: column
      justify-content: center
      max-width: 100%
      text-align: ${props.textAlign}
      font-size: ${props.fontSize}
    AvatarLetter
      text-transform: uppercase
    Image
      height: ${props.height}
      widht: ${props.width}
      border-radius: 50%
      padding: ${props.padding}
      margin: ${props.imgMargin}
      float: left
    `;
}

type Props= {
  displayName: string,
  width?: string,
  height?: string,
  radius?: string,
  margin?: string,
  imgMargin?: string,
  textAlign?: string,
  fontSize?: string,
  style?: Object,
  imageStyle?: Object,
  imagePath?: any,
  padding?: string,
}

class ContactAvatar extends Component {
  state: {
    imageLoaded: boolean,
  } = {
    imageLoaded: true,
  }
  props: Props;

  _handleImageError = () => {
    this.setState({ imageLoaded: false });
  }

  render() {
    const bgColor = getRandomColor(this.props.displayName.charAt(0));
    const style = _createStyle(this.props, bgColor);
    return (
      <div>
        {this.state.imageLoaded ?
          <img
            style={{ ...style.Image, ...this.props.imageStyle }}
            src={this.props.imagePath}
            onError={this._handleImageError}
            alt={getAvatarLetters(this.props.displayName)}
          />
        : <div style={{ ...style.ImagePlaceholder, ...this.props.style }}><p style={style.AvatarLetter}>{getAvatarLetters(this.props.displayName)}</p></div>}
      </div>
    );
  }
}

export default ContactAvatar;



// WEBPACK FOOTER //
// ./src/js/Components/ContactAvatar.js